import { Result } from "../model";
import axios from "axios";
import qs from "qs";
import config from "../config";
import Cookies from "js-cookie";
import Vue from "vue";
import { mapActions, mapMutations, mapState } from "vuex";

export default {
  /**
   * get 请求
   * @param {string} url
   * @param params
   * @returns {Promise<>}
   */
  async get(url, params) {
    let result = null;
    try {
      let response = await axios.get(config.host + url, {
        params: params,
        headers: {
          Authorization: this._getToken(url)
        }
      });
      result = response.data;
      if (result.errorCode == 200140) {
        // Cookies.remove("user");
        // this.MSet(null);
        Vue.prototype.$notify({
          message: result.errorMess
        });
        //Vue.prototype.$alert(result.errorMess);
      } else if (result.errorCode == 200150) {
        // Cookies.remove("user");
        // this.MSet(null);
        Vue.prototype.$notify({
          message: result.errorMess
        });
        // Vue.prototype.$alert(result.errorMess);
      }
    } catch (e) {
      result = await new Result(500, e, "服务器错误");
    }
    return result;
  },

  /**
   * post 请求
   * @param {string} url
   * @param body
   * @param params
   * @returns {Promise<>}
   */
  async post(url, body, params) {
    let result = null;
    try {
      let response = await axios.post(
        config.host + url,
        qs.stringify(body, {
          arrayFormat: "repeat"
        }),
        {
          params: params,
          headers: {
            Authorization: this._getToken(url)
          }
        }
      );
      result = response.data;

      if (result.errorCode == 200140) {
        // Cookies.remove("user");
        // this.MSet(null);
        Vue.prototype.$notify({
          message: result.errorMess
        });
        //Vue.prototype.$alert(result.errorMess);
      } else if (result.errorCode == 200150) {
        // Cookies.remove("user");
        // this.MSet(null);
        Vue.prototype.$notify({
          message: result.errorMess
        });
        Vue.prototype.$alert(result.errorMess);
      }
    } catch (e) {
      if (e && e.response && e.response.data.errorCode === 401) {
        window.$vue.$router.replace("/login");
      }

      result = await new Result(500, e, "服务器错误");
    }
    return result;
  },
  formatTime(date) {
    var year = date.getFullYear();
    var month = date.getMonth() + 1;
    month = month < 10 ? "0" + month : month;
    var day = date.getDate();
    day = day < 10 ? "0" + day : day;
    return year + "-" + month + "-" + day;
  },
  dateFormat(time) {
    var date = new Date(time);
    var year = date.getFullYear();
    /* 在日期格式中，月份是从0开始的，因此要加0
     * 使用三元表达式在小于10的前面加0，以达到格式统一  如 09:11:05
     * */
    var month =
      date.getMonth() + 1 < 10
        ? "0" + (date.getMonth() + 1)
        : date.getMonth() + 1;
    var day = date.getDate() < 10 ? "0" + date.getDate() : date.getDate();
    var hours = date.getHours() < 10 ? "0" + date.getHours() : date.getHours();
    var minutes =
      date.getMinutes() < 10 ? "0" + date.getMinutes() : date.getMinutes();
    var seconds =
      date.getSeconds() < 10 ? "0" + date.getSeconds() : date.getSeconds();
    // 拼接
    return (
      year +
      "-" +
      month +
      "-" +
      day +
      " " +
      hours +
      ":" +
      minutes +
      ":" +
      seconds
    );
  },
  compareDate(d1, d2) {
    let reg = new RegExp("-", "g");
    return new Date(d1.replace(reg, "/")) > new Date(d2.replace(reg, "/"));
  },
  ...mapMutations("user", ["MSet"]),
  ...mapState("user", ["info"]),
  _getToken(url) {
    //return "Bearer eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJ1bmlxdWVfbmFtZSI6IjUyODIzNSIsImh0dHA6Ly9zY2hlbWFzLnhtbHNvYXAub3JnL3dzLzIwMDUvMDUvaWRlbnRpdHkvY2xhaW1zL3NpZCI6IjUyODIzNSIsImh0dHA6Ly9zY2hlbWFzLm1pY3Jvc29mdC5jb20vd3MvMjAwOC8wNi9pZGVudGl0eS9jbGFpbXMvZXhwaXJhdGlvbiI6IjMvMy8yMDIwIDk6MDU6MzMgQU0iLCJuYmYiOjE1ODEwNjYzMzMsImV4cCI6MTU4MzIyNjMzMywiaWF0IjoxNTgxMDY2MzMzLCJpc3MiOiJ3d3cuNTExOC5jb20iLCJhdWQiOiJ3d3cuNTExOC5jb20ifQ.-Z839y2T-qUzZswhY8oHIbF3WsopKC6K6N3utq6NwG0";

    let user = Cookies.get("user");
    var data = this.dateFormat(new Date());
    var loginLink =
      process.env.NODE_ENV === "development"
        ? "http://localhost:8081/api/account/RefreshToken"
        : "https://ciyun.5118.com/api/account/RefreshToken";
    // loginLink = "http://localhost:8081/api/account/RefreshToken";

    //判断是否是登录操作
    var isLogin = url.indexOf("login") > -1;

    //url不包含login
    if (user && JSON.parse(user).userInfo.tokenEndTime && !isLogin) {
      let tokenEndTime = JSON.parse(user).userInfo.tokenEndTime;

      //对比日期大小，第一个参数大于第二个参数则返回true
      var compareDateValue = this.compareDate(
        this.dateFormat(data),
        this.dateFormat(tokenEndTime)
      );

      if (compareDateValue) {
        // //已过期
        // //清空cookie
        Cookies.remove("user");
        // this.MSet(null);
      }
    }

    if (user) {
      return JSON.parse(user).token;
    }
    return "";
  }
};
